import { render, staticRenderFns } from "./operateRemoveOff.vue?vue&type=template&id=499e32f0&"
import script from "./operateRemoveOff.vue?vue&type=script&lang=ts&"
export * from "./operateRemoveOff.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports